import { MathUtils as a } from "three";
const p = (o) => o.map((t) => t * a.RAD2DEG);
export {
  p as RadToDegV3
};
//# sourceMappingURL=index20.js.map
